// import PreSeed from "@/assets/images/PreSeed-Stage.png";
// import Seed from "@/assets/images/Seed-Stage.png";
// import SeriesA from "@/assets/images/SeriesA-Stage.png";
// import SeriesB from "@/assets/images/SeriesB-Stage.png";
// import SeriesC from "@/assets/images/SeriesC-Stage.png";
// import PreIPO from "@/assets/images/PreIPO-Stage.png";
import PreSeed from "@/assets/images/PreSeed-Stage.png";
import Seed from "@/assets/images/Seed-Stage.png";
import SeriesA from "@/assets/images/SeriesA-Stage.png";
import SeriesB from "@/assets/images/SeriesB-Stage.png";
import SeriesC from "@/assets/images/SeriesC-Stage.png";
import Late from "@/assets/images/Late-Stage.png";
import PreIPO from "@/assets/images/PreIPO-Stage.png";
import IPO from "@/assets/images/ipo-logo.svg";

const getIcon = (type) => {
  let icon;
  switch (type) {
    case "pre-seed":
      icon = PreSeed.src;
      break;
    case "seed":
      icon = Seed.src;
      break;
    case "series-a":
      icon = SeriesA.src;
      break;
    case "series-b":
      icon = SeriesB.src;
      break;
    case "series-c":
      icon = SeriesC.src;
      break;
    case "late-stage":
      icon = Late.src;
      break;
    case "pre-ipo":
      icon = PreIPO.src;
      break;
    case "ipo":
      icon = IPO.src;
      break;
    default:
      icon = PreIPO.src;
      break;
  }

  return icon;
};

export default getIcon;
